export default "__VITE_ASSET__D5ovmVk5__"